module.exports = __webpack_public_path__ + "static/share-workwise-c06950d7e997ee4027ab2c0434a8ef3b.png";